import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';
import { InputModel } from '../models/input/input.model';
import { JsonEditorModel } from '../models/json-editor/json-editor.model';
import { JsonEditorStylingModel } from '../models/json-editor/json-editor-styling.model';

export const /** @type {?} */ JsonEditorTemplates = {
  defaultTemplate: {
    property: new JsonEditorModel({
      display: true,
      disable: false,
      lockKeys: false,
      showButtons: 'hover',
      rowButtons: [
        [
          { 'name': 'moveUp', 'icon': 'keyboard_arrow_up' },
          { 'name': 'moveDown', 'icon': 'keyboard_arrow_down' }
        ],
        [
          { 'name': 'indent', 'icon': 'format_indent_increase' },
          { 'name': 'outdent', 'icon': 'format_indent_decrease' }
        ],
        [
          { 'name': 'clone', 'icon': 'content_copy' },
          { 'name': 'delete', 'icon': 'delete' },
          { 'name': 'insert', 'icon': 'playlist_add' }
        ]
      ],
      data: null
    }),
    style: new JsonEditorStylingModel()
  }
}
